import React from "react";
import styled, { withTheme } from "styled-components";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import AccentButton from "../../ui-library/Buttons/AccentButton/AccentButton";
import CardSeparator from "../CardSeparator/CardSeparator";

const CardWrapper = styled.div`
  background: white;
  box-shadow: 0px 0px 6px #00000029;
  border-radius: 12px;
  padding: 68px 53px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  white-space: pre-wrap;
  direction: ltr;
  @media (max-width: 1024px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  width: fit-content;
  align-self: flex-end;
  margin-top: auto !important;
`;

const StyledAccentButton = styled(AccentButton)`
  width: fit-content;
  align-self: flex-end;
  margin-top: auto !important;
`;

const LogoContainer = styled.div`
  align-self: flex-end;
  .table-image {
    height: 60px;
  }
  @media (max-width: 576px) {
    .table-image {
      margin-top: 2rem;
    }
  }
`;

const HomeCard = (props) => {
  const {
    header,
    renderHeader,
    bodyText,
    buttonText,
    primaryButton,
    btnAction,
    logo,
  } = props;
  return (
    <CardWrapper data-testid="home-card-widget">
      {header && <h3>{header}</h3>}
      {renderHeader}
      <CardSeparator style={props.cardHeader ?? "-lg"} />
      <p className="mt-4 mb-1">{bodyText}</p>
      {buttonText && (
        <>
          {primaryButton ? (
            <StyledPrimaryButton onClick={btnAction}>
              {buttonText}
            </StyledPrimaryButton>
          ) : (
            <StyledAccentButton onClick={btnAction}>
              {buttonText}
            </StyledAccentButton>
          )}
        </>
      )}
      {logo && (
        <LogoContainer>
          <img src={logo} alt="Study Logo" className="table-image" />
        </LogoContainer>
      )}
    </CardWrapper>
  );
};

export default withTheme(HomeCard);
